import type { ReactNode } from "react";
import { ExploreIcon, LiveIcon, PauseIcon, PlayIcon, ShareIcon, SoundIcon } from "./Icons";

interface DockButtonProps {
  label: string;
  icon: ReactNode;
  active?: boolean;
  pressed?: boolean;
  onClick: () => void;
  describedBy?: string;
}

function DockButton({ label, icon, active = false, pressed, onClick, describedBy }: DockButtonProps) {
  return (
    <button
      className={`dock-button${active ? " is-active" : ""}`}
      type="button"
      onClick={onClick}
      aria-pressed={pressed}
      aria-describedby={describedBy}
    >
      <span className="dock-button__icon">{icon}</span>
      <span className="dock-button__label">{label}</span>
    </button>
  );
}

interface ControlDockProps {
  isPaused: boolean;
  isLive: boolean;
  isExploring: boolean;
  soundEnabled: boolean;
  onPause: () => void;
  onLive: () => void;
  onExplore: () => void;
  onSound: () => void;
  onShare: () => void;
}

export function ControlDock(props: ControlDockProps) {
  return (
    <div className="control-dock" role="group" aria-label="表示操作">
      <DockButton
        label={props.isPaused ? "RESUME" : "PAUSE"}
        icon={props.isPaused ? <PlayIcon /> : <PauseIcon />}
        active={props.isPaused}
        onClick={props.onPause}
        describedBy="pause-help"
      />
      <DockButton label="LIVE" icon={<LiveIcon />} active={props.isLive} pressed={props.isLive} onClick={props.onLive} />
      <DockButton label="EXPLORE" icon={<ExploreIcon />} active={props.isExploring} pressed={props.isExploring} onClick={props.onExplore} />
      <DockButton label="SOUND" icon={<SoundIcon muted={!props.soundEnabled} />} active={props.soundEnabled} pressed={props.soundEnabled} onClick={props.onSound} />
      <DockButton label="SHARE" icon={<ShareIcon />} onClick={props.onShare} />
    </div>
  );
}
